import React from "react";
import { useSelector } from "react-redux";
import { DashSel } from "@/features/dashboard";
import { Select } from "antd";
import { TitleCase } from "@/utils/string";

import { usePerformanceContext } from "./hook";
import styles from "./styles.less";

export default () => {
  const uniqueCountry = useSelector(DashSel.uniqueCountry);
  const { country, setCountry } = usePerformanceContext();

  return (
    <Select
      mode="multiple"
      className={styles.countrySelect}
      value={country}
      placeholder="Select country"
      onChange={e => setCountry(e)}
      style={{width: 200}}
    >
      {uniqueCountry
        .filter(c => !country.includes(c))
        .map(c => (
          <Select.Option key={c} value={c}>
            {TitleCase(c)}
          </Select.Option>
        ))}
    </Select>
  );
};
